import React from 'react';
import classNames from 'classnames';
import EmptyState from 'modules/common/components/EmptyState';
import usePublicRuntimeConfig from 'modules/common/hooks/usePublicRuntimeConfig';
import { SiWhatsapp as IconWhatsApp } from 'react-icons/si';
import CopyButton from 'modules/common/components/CopyButton';

type AuthorizationScreenProps = {
  type: string;
} & React.HTMLAttributes<HTMLDivElement>;

const AuthorizationScreen: React.FC<AuthorizationScreenProps> = ({ children, type, className, ...props }) => {
  const { whatsappJulien, emailHello } = usePublicRuntimeConfig();
  let title = "Vous n'êtes pas autorisé";
  let subtitle = (
    <>
      Vous n&apos;avez pas le droit d&apos;effectuer cette action.
      <br />
      <br />
      contactez nous sur WhatsApp pour toute question
    </>
  );
  let cta = 'Contactez-nous sur WhatsApp';
  let onClick = () => {
    window.open(whatsappJulien, '_blank');
  };
  let icon = IconWhatsApp;

  if (type === 'member') {
    title = "Votre profil n'est pas encore validé";
    subtitle = (
      <>
        Notre équipe fait tout son possible pour valider les profils rapidement
        <br />
        <br />
        <strong>Vous serez informé par email</strong> dès validation de votre profil.
        <br />
        <br />
        Afin d&apos;être sûr de recevoir cet email et qu&apos;il ne finisse pas dans vos SPAMS, <strong>veillez à ajouter l&apos;email</strong>{' '}
        suivant à votre liste de contacts
        <br />
        <br />
        <strong>
          <CopyButton value={emailHello}>{emailHello}</CopyButton>
        </strong>
        <br />
        <br />
        Si vous êtes pressé, contactez nous sur WhatsApp
      </>
    );
  }

  return (
    <div className={classNames('p-5 sm:p-24 border border-gray-100 shadow-sm', className)} {...props}>
      <EmptyState title={title} subtitle={subtitle} cta={cta} onClick={onClick} icon={icon} />
    </div>
  );
};

export default AuthorizationScreen;
